<template>
    <div class="appform" :class="{ 'appform--am-subject': showSubjectAccent, 'appform--am-institution': isInstitutionSchoolDayLink }" :style="formThemeStyle">
        <div class="content" v-if="project_need_qualification === 'YES'">
            <div v-if="!isInstitutionSchoolDayLink" style="display: flex;width: 100%;align-items: flex-start;">
                <div style="display: flex;flex: 1;">
                    <img src="../../assets/image/logo.png" style="width: 240px;height: auto; margin-right: 32px" />
                </div>
                <div style="text-align: right;">
                    <p style="color: #FF8E3B;font-size: 28px;font-family: GravityBold">Restricted Registration</p>
                    <p style="margin-top: 10px;color: #FF8E3B;font-size: 18px;font-family: GravityBold">
                        {{ project_name }}
                    </p>
                </div>
            </div>
            
            <div class="qualification-notice" style="margin: 30px 0;padding: 20px;background-color: #FFF3E8;border-radius: 8px;">
                <p style="color: #FF8E3B;font-size: 16px;line-height: 1.5;">
                    This project requires qualification verification before registration. Open registration is not available.
                    Please wait for results announcement and invitation from your qualification event.
                </p>
            </div>
        </div>
        <div class="content" v-if="project_need_qualification === 'NO'">
            <div v-show="flowStep === 1">
            <div v-if="!isInstitutionSchoolDayLink" style="display: flex;width: 100%;align-items: flex-start;">
                <div style="display: flex;flex: 1;">
                    <img src="../../assets/image/logo.png" style="width: 240px;height: auto; margin-right: 32px" />
                </div>
                <div style="text-align: right;">
                    <p style="color: #FF8E3B;font-size: 28px;font-family: GravityBold">Student Registration
                        Form</p>
                    <p style="margin-top: 10px;color: #FF8E3B;font-size: 18px;font-family: GravityBold">
                        <span v-if="account_type === '教育机构'">coordinated by </span>
                        <span v-else>register under </span>
                        {{ account_nameEN.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') }}
                        <div style="color: #FF8E3B;">Advisor: {{ advisor_name }}</div>
                    </p>
                </div>
            </div>
            <div v-if="isInstitutionSchoolDayLink" class="am-paid-landing">
                <div class="am-paid-header">
                    <div class="am-paid-logo-strip">
                        <img class="am-paid-logo" :src="institutionBrandLogo" />
                        <img v-if="institutionSubjectLogo" class="am-paid-subject-logo" :src="institutionSubjectLogo" />
                    </div>
                </div>

                <div class="am-paid-hero" :style="{ borderColor: amSubjectTheme.accent }">
                    <div>
                        <div class="am-paid-kicker">{{ amInstitutionKicker }}</div>
                        <h1>{{ project_name || amSubjectTheme.subject }}</h1>
                        <p>
                            Complete your student registration for {{ amSubjectTheme.subject }} under
                            {{ formattedAccountName }}.
                        </p>
                    </div>
                    <div class="am-paid-chip" :style="{ backgroundColor: amSubjectTheme.accent }">
                        {{ amInstitutionChipText }}
                    </div>
                </div>

                <div class="am-paid-covered">
                    {{ amInstitutionNotice }}
                </div>

                <div class="am-paid-facts">
                    <div class="am-paid-fact">
                        <span>Institution</span>
                        <strong>{{ formattedAccountName }}</strong>
                    </div>
                    <div class="am-paid-fact">
                        <span>Advisor</span>
                        <strong>{{ advisor_name || 'Set by your institution' }}</strong>
                    </div>
                    <div class="am-paid-fact">
                        <span>Registration fee</span>
                        <strong>{{ amInstitutionFeeLabel }}</strong>
                    </div>
                    <div class="am-paid-fact">
                        <span>Subject</span>
                        <strong>{{ amSubjectTheme.subject }}</strong>
                    </div>
                </div>

                <div class="am-paid-format">
                    <span :style="{ backgroundColor: amSubjectTheme.accent }"></span>
                    Individual | One topic | 5 stages | Up to 10 active hours | 24-hour window | Grades 9-12
                </div>
            </div>

            <div  class="title1">{{ project_name }}</div>
            <el-form :model="form" :rules="formRules" ref="form">
                <el-form-item v-if="isNimTrackLink" label="Registration Option" prop="nim_registration_mode" required>
                    <el-radio-group v-model="form.nim_registration_mode" style="display:flex;flex-direction:column;align-items:flex-start;gap:8px;">
                        <el-radio label="combo">NIL + this track (combo)</el-radio>
                        <el-radio label="makeup">Already have NIL — register this track</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div class="row single-cycle-row" v-if="isNimTrackLink && form.nim_registration_mode === 'makeup'">
                    <div class="item" style="width:100%;">
                        <el-form-item label="NIL Transcript ID" prop="nil_transcript_id" required>
                            <div style="display:flex;gap:8px;align-items:flex-start;">
                                <el-input v-model="form.nil_transcript_id" placeholder="Application / transcript ID" style="flex:1;"></el-input>
                                <el-button type="primary" :loading="verifyingTranscript" @click="verifyNilTranscript">Verify NIL Transcript</el-button>
                            </div>
                            <p style="color:#666;font-size:12px;margin-top:8px;">Enter the same email as on the NIL transcript (Email field below), then verify. Score must be ≥ 60.</p>
                            <p v-if="nilTranscriptVerified" style="color:#146C43;font-size:12px;margin-top:6px;">Transcript verified.</p>
                        </el-form-item>
                    </div>
                </div>
                <div class="row single-cycle-row" v-if="isNimProject && reviewCycles.length > 0">
                    <div class="item">
                        <el-form-item label="Select Review Cycle" prop="application_cycle" required>
                            <el-select v-model="form.application_cycle" style="width: 100%;" placeholder="Please select"
                                :disabled="isNimTrackLink && form.nim_registration_mode === 'makeup' && !nilTranscriptVerified">
                                <el-option v-for="(cycle, index) in reviewCycles" :key="index"
                                    :value="cycle.name" :label="formatCycleOptionLabel(cycle)"></el-option>
                            </el-select>
                            <div class="cycle-hint" v-if="selectedCycleFeeLines.length > 0">
                                <p v-for="line in selectedCycleFeeLines" :key="line.key">{{ line.text }}</p>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="item">
                        <el-form-item label="Given Name (Native Language)" prop="givenName">
                            <div class="input">
                                <el-input v-model="form.givenName" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="Last Name (Native Language)" prop="lastName">
                            <div class="input">
                                <el-input v-model="form.lastName" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="item">
                        <el-form-item label="Given Name (EN)" prop="givenName_pinyin">
                            <div class="input">
                                <el-input v-model="form.givenName_pinyin" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="Last Name (EN)" prop="lastName_pinyin">
                            <div class="input">
                                <el-input v-model="form.lastName_pinyin" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="item">
                        <el-form-item label="Email" prop="email">
                            <div class="input">
                                <el-input v-model="form.email" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="High School Graduation" prop="graduation">
                            <div class="input">
                                <el-select v-model="form.graduation" style="width: 400px;" placeholder="Please select"
                                    :popper-append-to-body="false" popper-class="customSelect">
                                    <el-option v-for="(year, index) in years" :value="year" :key="index"
                                        :label="year"></el-option>
                                </el-select>
                            </div>
                            <StudentEligibilityNotice />
                        </el-form-item>
                    </div>
                </div>

                <div class="row" style="align-items: flex-start">
                    <div class="item">
                        <el-form-item label="Guardian's Email" prop="student_guardian_first_email">
                            <div>
                                <div class="input">
                                    <el-input v-model="form.student_guardian_first_email"
                                        placeholder="Please input"></el-input>
                                </div>
                            </div>
                            <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">The guardian's
                                email only serves as a backup for communication if necessary.</p>

                        </el-form-item>
                    </div>

                    <div v-if="account_type === '教育机构'" class="item">
                        <el-form-item label="School Name(EN)" prop="account_id">
                            <div>
                                <div class="input" style="margin-top: 10px;">
                                    <el-select v-model="form.sub_account_id" :multiple="false" filterable :clearable="true"
                                        remote reserve-keyword placeholder="Please input keyword"
                                        :remote-method="remoteMethod" :loading="loading" loading-text="Searching schools..."
                                        no-data-text="No Result" style="width: 400px;" @change="handleAccoutChanged"
                                        @blur="handleBlurChanged">
                                        <el-option v-for="(account, index) in accounts" :key="index"
                                            :label="account.account_nameEN ? account.account_nameEN : account.account_name"
                                            :value="account._id.$id">
                                            <el-tooltip :content="account.account_nameEN ? account.account_nameEN : account.account_name" placement="top" effect="dark" :open-delay="300">
                                                <span style="float: left; max-width: 280px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                    {{ account.account_nameEN ? account.account_nameEN : account.account_name }}
                                                </span>
                                            </el-tooltip>
                                            <el-tag v-if="account.school_search_match_type === 'semantic'" size="mini" type="warning" effect="plain" style="float: right; margin-top: 7px;">
                                                {{ account.school_search_match_label || 'Similar match' }}
                                            </el-tag>
                                        </el-option>
                                    </el-select>
                                </div>
                                <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">While your registration will be coordinated by {{account_nameEN}}, you still need to provide your full-time school's name. Please enter
                                    the school's official name with initial caps of each word. If your school does not appear in the dropdown menu, just type in the full name of your school manually.<br><br>* Select your country/region first before searching for schools.</p>
                            </div>
                        </el-form-item>
                    </div>
                    
                    
                    <!-- <div class="item">

                        <el-form-item label="Adviser" v-if="register_type == 'share'" prop="">
                            <div>
                                <div class="input">
                                    <el-input v-model="advisor_name" disabled
                                        placeholder="Please input"></el-input>
                                </div>
                            </div>
                        </el-form-item>
                    </div> -->
                </div>
            </el-form>

            <div class="terms flex items-center justify-center" style="margin-top: 20px;">
                <div @click="isAgree = !isAgree" style="display: flex; align-items: center">
                    <img style="width: 16px;height: 16px;cursor: pointer;margin-right: 16px;" v-if="!isAgree"
                        :src="require('../../assets/image/unchecked.png')" />
                    <img style="width: 16px;height: 16px;cursor: pointer;margin-right: 16px;" v-else
                        :src="require('../../assets/image/checked.png')" />
                </div>
                <p style="line-height: 20px;"> I have read and agree to the <a href="#/privacy-policy" target="_blank" rel="noopener noreferrer" style="color: #409EFF; text-decoration: underline;" @click.stop>Privacy Policy</a>, and I agree that EAE may use my provided information to set up a personal account and to email me about notifications, reminders, and extracurricular opportunities.</p>
            </div>
            <div v-if="project.deadline_date && project.deadline_date < (new Date().getTime())" style="color: #D3A12A; font-size: 16px; font-weight: bold;margin: 20px 0px;text-align: center;">
                The registration deadline has passed.<br>
                <span style="font-size: 12px;color: #666;">The registration deadline is {{project.deadline_string}} in your local time.</span>
            </div>
            <div v-if="!(project.deadline_date && project.deadline_date < (new Date().getTime()))" class="submit">
                <ApplicationConductNotice />
                <div class="submitBtn" @click="submit">{{ requiresIntegrity ? 'Continue' : 'Submit' }}</div>
            </div>
            <div v-if="isInstitutionSchoolDayLink" class="am-paid-footer">
                International Academic Marathon Association
            </div>
            </div>

            <div v-show="flowStep === 2 && requiresIntegrity" class="integrity-wrap">
                <div class="title1" style="margin-bottom: 8px;">Integrity Confirmation</div>
                <div class="title1" style="font-size: 12px;margin-top: 0;margin-bottom: 18px;">Please review and acknowledge each integrity policy</div>
                <RegistrationIntegrityFlow
                    ref="integrityFlow"
                    :program-name="integrityProgramName"
                    :theme-color="integrityThemeColor"
                    :theme-secondary="integrityThemeSecondary"
                    @back="backToForm"
                    @complete="goToConfirm"
                />
            </div>

        <AccountFormConfirmDialog
            :show.sync="showConfirmDialog"
            :as-page="requiresIntegrity"
            :email="form.email"
            :highlightFields="confirmHighlightFields"
            :normalFields="confirmNormalFields"
            :requireStudentEligibilityConfirm="true"
            :themeColor="requiresIntegrity ? integrityThemeColor : '#D3A12A'"
            @confirmed="doSubmit"
            @back="onConfirmBack"
        />
        </div>
    </div>
</template>
<script>
import {
    createApplicationByProjectAndAccount,
    createNimStudentRegistration,
    validateNilTranscriptForMakeup,
    getAccount,
    getProjectInfoByCode,
    getProjectManageByCode,
    getContactInfo,
    getExclusivePartners,
    postRequest
} from '../../api/eae'
import AccountFormConfirmDialog from '../../components/AccountFormConfirmDialog.vue'
import ApplicationConductNotice from '../../components/ApplicationConductNotice.vue'
import StudentEligibilityNotice from '../../components/StudentEligibilityNotice.vue'
import RegistrationIntegrityFlow from './components/RegistrationIntegrityFlow.vue'
import { exclusivePartnersMixin } from '../../utils/exclusivePartners'
import { checkAndConfirmName } from '../../utils/nameValidator'
import { searchSchoolOptions } from '../../utils/schoolSearch'
import { showSuspiciousApplicationNotice } from '../../utils/suspiciousApplicationNotice'
import {
    buildReviewCycleFeeLines,
    buildComboCycleCopyLines,
    buildReviewCycleOptionLabel,
    getReviewCycleDisplayName,
    shouldShowReviewCycle
} from '../../utils/nimReviewCycles'
import { resolveAmSubjectTheme } from '../../utils/amSubjectTheme'
import '../../assets/common/font.css'
export default ({
    name: 'index',
    components: { AccountFormConfirmDialog, ApplicationConductNotice, StudentEligibilityNotice, RegistrationIntegrityFlow },
    mixins: [exclusivePartnersMixin],
    data() {
        return {
            project:{},
            project_code: this.$route.query.project_code,
            project_need_qualification:'NO',
            account_id: this.$route.query.account_id,
            account_type: '',
            referral_email: '',
            isAgree: false,
            loading: false,
            years: [],
            accounts: [],
            flowStep: 1,
            showConfirmDialog: false,
            form: {
                project_code: '',
                account_id: '',
                institution_app_id: '',
                participation_arrangement: '',
                sub_account_id: '', 
                sub_account_nameEN: '',
                contact_id: '',
                lastName: '',
                givenName: '',
                lastName_pinyin: '',
                givenName_pinyin: '',
                graduation: '',
                email: '',
                student_guardian_first_email: '',
                country: '',
                application_cycle: '',
                nim_registration_mode: '',
                nil_transcript_id: '',
            },
            nilTranscriptVerified: false,
            verifyingTranscript: false,
            companionNilProject: null,
            rawReviewCycles: [],
            formRules: {
                application_cycle: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.isNimProject && this.reviewCycles.length > 0 && !value) {
                                callback(new Error('Please select'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ],
                nim_registration_mode: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.isNimTrackLink && !value) {
                                callback(new Error('Please select'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ],
                nil_transcript_id: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.isNimTrackLink && this.form.nim_registration_mode === 'makeup' && !value) {
                                callback(new Error('Please input'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                givenName: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                lastName: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                account_nameEN: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                province: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                country: [
                    { required: true, message: "Please select", trigger: "change" },
                ],
                lastName_pinyin: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                givenName_pinyin: [
                    { required: true, message: "Please choose", trigger: "change" },
                ],
                graduation: [
                    { required: true, message: "Please choose", trigger: "change" },
                ],
                sub_account_nameEN: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.account_type === '教育机构' && !value) {
                                callback(new Error('Please input'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ],
                email: [
                    { required: true, message: "Please input", trigger: "change" },
                    { type: 'email', message: 'Please enter a valid email address', trigger: 'change' }
                ],
                student_guardian_first_email: [
                    { required: true, message: "Please input", trigger: "change" },
                    { type: 'email', message: 'Please enter a valid email address', trigger: 'change' }
                ],
            },
            account_nameEN: '',
            project_name: '',
            register_type: 'individual',
        }
    },
    computed: {
        projectBu() {
            return this.project && this.project.project_BU
                ? String(this.project.project_BU).toUpperCase()
                : ''
        },
        isInstitutionSchoolDayLink() {
            // Any BU with School day exclusive link (institution_app_id). Not AM-only.
            return !!this.form.institution_app_id
        },
        isAMPaidInstitutionLink() {
            return this.isInstitutionSchoolDayLink
        },
        hasSubjectTheme() {
            // Subject accent themes currently defined for AM; extensible per BU later.
            return this.projectBu === 'AM'
        },
        showSubjectAccent() {
            // B-7: only School day landing uses subject accent; Standard uses generic EAE form.
            return this.isInstitutionSchoolDayLink && this.hasSubjectTheme
        },
        formThemeStyle() {
            if (!this.isInstitutionSchoolDayLink) {
                return {}
            }
            const style = {}
            if (this.hasSubjectTheme) {
                style['--am-accent'] = this.amSubjectTheme.accent
            }
            style.backgroundColor = '#1B3B6F'
            return style
        },
        formattedAccountName() {
            const name = this.account_nameEN || 'your institution'
            return name.split(' ').filter(Boolean).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
        },
        amInstitutionKicker() {
            return this.isAMPaidInstitutionLink ? 'Set by your institution' : 'Standard registration'
        },
        amInstitutionChipText() {
            return this.isAMPaidInstitutionLink ? 'Fee covered' : 'Student pays'
        },
        amInstitutionNotice() {
            if (this.isAMPaidInstitutionLink) {
                return 'Your registration fee is covered by ' + this.formattedAccountName + '. No payment is required from students.'
            }
            return 'Students register and pay individually. Your school is not invoiced, and students take part in the official competition window.'
        },
        amInstitutionFeeLabel() {
            return this.isAMPaidInstitutionLink ? 'Covered by institution' : 'Paid by student'
        },
        amSubjectTheme() {
            if (this.hasSubjectTheme) {
                return resolveAmSubjectTheme(this.project_code, this.project_name || 'Academic Marathon')
            }
            return {
                subject: this.project_name || 'Program',
                discipline: this.projectBu || 'EAE',
                accent: '#FF8E3B',
                logo: ''
            }
        },
        institutionBrandLogo() {
            if (this.projectBu === 'AM') {
                return require('../../assets/image/logo_am.png')
            }
            return require('../../assets/image/header-logo.png')
        },
        institutionSubjectLogo() {
            if (this.hasSubjectTheme && this.amSubjectTheme.logo) {
                return require('../../assets/image/am_subject_logos/' + this.amSubjectTheme.logo)
            }
            const project = this.project || {}
            return project.project_logo || project.logo_url || project.project_pic || ''
        },
        amSubjectLogo() {
            return this.institutionSubjectLogo
        },
        requiresIntegrity() {
            return ['DSA', 'AM', 'ICS'].indexOf(this.projectBu) !== -1
        },
        integrityProgramName() {
            if (this.projectBu === 'AM') return 'AM'
            if (this.projectBu === 'ICS') return 'ICS'
            if (this.projectBu === 'DSA') return 'DSA'
            return this.project_name || 'EAE'
        },
        integrityThemeColor() {
            if (this.projectBu === 'AM') return '#FF8C00'
            if (this.projectBu === 'ICS') return '#0a509A'
            return '#1D5D9B'
        },
        integrityThemeSecondary() {
            if (this.projectBu === 'AM') return '#E67E00'
            if (this.projectBu === 'ICS') return '#083d75'
            return '#154A7A'
        },
        isNimProject() {
            return String((this.project && this.project.project_BU) || '').toUpperCase() === 'NIM'
        },
        isNimNilLink() {
            return /NIL$/i.test(String(this.project_code || this.form.project_code || ''))
        },
        isNimTrackLink() {
            return this.isNimProject && !this.isNimNilLink
        },
        confirmHighlightFields() {
            return [
                { label: 'Name', value: (this.form.givenName_pinyin + ' ' + this.form.lastName_pinyin).trim() },
                { label: 'Email', value: this.form.email },
                { label: 'Country/Region', value: this.form.country },
                { label: 'Review Cycle', value: this.selectedCycleDisplayName }
            ].filter(f => f.value)
        },
        confirmNormalFields() {
            return [
                { label: 'School/Organization', value: this.form.account_nameEN },
                { label: 'Graduation Year', value: this.form.graduation },
                { label: 'Province', value: this.form.province },
            ].filter(f => f.value)
        },
        reviewCycles() {
            return this.rawReviewCycles.filter(cycle => shouldShowReviewCycle(cycle, this.project))
        },
        selectedCycle() {
            return this.reviewCycles.find(cycle => cycle.name === this.form.application_cycle) || null
        },
        selectedCycleFeeLines() {
            if (this.isNimTrackLink && this.form.nim_registration_mode === 'combo') {
                return buildComboCycleCopyLines(this.selectedCycle, this.project, this.companionNilProject, this.formatCycleDate, {
                    entryDates: this.rawReviewCycles
                })
            }
            return buildReviewCycleFeeLines(this.selectedCycle, this.project, this.formatCycleDate, {
                entryDates: this.rawReviewCycles,
                isMakeup: this.form.nim_registration_mode === 'makeup'
            })
        },
        selectedCycleDisplayName() {
            return getReviewCycleDisplayName(this.selectedCycle || this.form.application_cycle)
        }
    },
    watch: {
        'form.nil_transcript_id'() {
            this.nilTranscriptVerified = false
        },
        'form.nim_registration_mode'() {
            this.form.nil_transcript_id = ''
            this.nilTranscriptVerified = false
            this.form.application_cycle = ''
        }
    },
    mounted() {

        this.form.project_code = this.project_code
        this.form.account_id = this.account_id
        this.form.institution_app_id = this.$route.query.institution_app_id || ''
        this.form.participation_arrangement = this.$route.query.participation_arrangement || ''
        // Explicit Standard registration link must keep independent payment (no School day auto-link).
        if (this.form.participation_arrangement === 'Standard registration') {
            this.form.institution_app_id = ''
        }
        this.form.referral_email = this.referral_email
        let current_year = new Date().getFullYear()
        let start_year = current_year +1
        for (let i = 0; i < 5; i++) {
            let year = start_year + i
            this.years.push(year)
        }
        if (this.$route.query.category_id) {
            this.form.category_id = this.$route.query.category_id
        }
        let contact_id = ""
        if (this.$route.query.contact_id) {
            contact_id = this.$route.query.contact_id
        } else if (this.$route.query.advisor_id) {
            contact_id = this.$route.query.advisor_id
        }
        if (contact_id && contact_id != '') {//老师分享过来的
            this.register_type = 'share'
            this.requestContactInfo(contact_id)
        } 
        this.requestAccountInfo()
        
        this.requestProjectInfo()
        if (this.project_code) {
            this.fetchExclusivePartners(this.project_code)
        }
    },
    methods: {
        normalizeTimestamp(rawTimestamp) {
            if (!rawTimestamp) {
                return 0
            }
            const timestamp = Number(rawTimestamp)
            if (!Number.isFinite(timestamp)) {
                return 0
            }
            return timestamp.toString().length === 10 ? timestamp * 1000 : timestamp
        },

        applyProjectDeadline(deadlineTimestamp, addDays = 0) {
            const normalizedDeadline = this.normalizeTimestamp(deadlineTimestamp)
            if (!normalizedDeadline) {
                return
            }
            const deadlineDate = new Date(normalizedDeadline + addDays * 24 * 60 * 60 * 1000)
            deadlineDate.setHours(23, 59, 59)
            const utc8String = deadlineDate.toLocaleString('en-US', { timeZone: 'Asia/Shanghai' })
            this.project.deadline_string = utc8String
            this.project.deadline_date = new Date(utc8String).getTime()
        },

        requestCustomDeadline() {
            const contactId = this.$route.query.contact_id || this.$route.query.advisor_id || this.form.contact_id
            if (!contactId || !this.project_code) {
                return
            }
            postRequest({
                function: 'getAccountApplicationByContact',
                contact_id: contactId,
                project_code: this.project_code
            }).then((res) => {
                const customDeadline = res?.data?.data?.custom_deadline_date
                if (customDeadline) {
                    this.applyProjectDeadline(customDeadline, 0)
                }
            }).catch((error) => {
                console.error('Failed to fetch custom ddl:', error)
            })
        },

        requestContactInfo(contact_id) {
            getContactInfo(contact_id).then((res) => {
                let result = res.data.data
                
                this.form.contact_id = contact_id
                this.form.referral_email = result.contact_email
                this.advisor_name = result.contact_enName && result.contact_enName !== "" ? result.contact_enName : (result.contact_givenName + ' ' + result.contact_lastName)
                this.account_nameEN = result.account.account_nameEN
            })
        },


        requestAccountInfo() {
            getAccount(this.account_id).then((res) => {
                let result = res.data.data
                this.account_nameEN = result.account_nameEN
                this.account_type = result.account_type
                this.form.account_id = this.account_id
                this.form.country = result.account_country
                this.checkExclusivePartner(this.form.country)
            })
        },


        requestProjectInfo() {
            getProjectInfoByCode(this.project_code).then((res) => {
                this.project = res.data
                // Default behavior: formal ddl + 7 days
                this.applyProjectDeadline(this.project.deadline_date, 7)

                this.project_name = res.data.project_ename
                this.project_need_qualification = res.data.project_need_qualification? res.data.project_need_qualification : 'NO'
                if (String(this.project.project_BU || '').toUpperCase() === 'NIM') {
                    if (/NIL$/i.test(String(this.project_code || ''))) {
                        this.form.nim_registration_mode = 'nil_only'
                    } else if (!this.form.nim_registration_mode) {
                        this.form.nim_registration_mode = 'combo'
                    }
                    this.loadCompanionNilProject()
                }
                // Override with account application's custom ddl when available
                this.requestCustomDeadline()
                this.loadReviewCycles(this.project_code)
            })
        },

        loadCompanionNilProject() {
            const code = String(this.project_code || this.form.project_code || '')
            const year = (code.match(/^(\d{4})/) || [])[1]
            if (!year || /NIL$/i.test(code)) {
                this.companionNilProject = null
                return
            }
            getProjectInfoByCode(year + 'NIL').then((res) => {
                this.companionNilProject = res.data || null
            }).catch(() => {
                this.companionNilProject = null
            })
        },

        verifyNilTranscript() {
            const transcriptId = (this.form.nil_transcript_id || '').trim()
            const email = (this.form.email || '').trim()
            if (!transcriptId) {
                this.$message.warning('Please enter your NIL Transcript ID.')
                return
            }
            if (!email) {
                this.$message.warning('Please enter your email (same as the NIL transcript) before verifying.')
                return
            }
            this.verifyingTranscript = true
            validateNilTranscriptForMakeup(email, transcriptId).then((res) => {
                const result = res && res.data ? res.data : {}
                if (result.code === 0) {
                    this.nilTranscriptVerified = true
                    this.$message.success('NIL transcript verified.')
                } else {
                    this.nilTranscriptVerified = false
                    this.$message.error(result.msg || 'Transcript verification failed.')
                }
            }).catch(() => {
                this.nilTranscriptVerified = false
                this.$message.error('Transcript verification failed. Please try again.')
            }).finally(() => {
                this.verifyingTranscript = false
            })
        },

        loadReviewCycles(projectCode) {
            if (!projectCode) {
                this.rawReviewCycles = []
                this.form.application_cycle = ''
                return
            }
            getProjectManageByCode(projectCode).then((res) => {
                const manage = res.data || {}
                const entries = Array.isArray(manage.entry_date) ? manage.entry_date : []
                this.rawReviewCycles = entries.filter(cycle => cycle && cycle.name)
                if (this.reviewCycles.length === 0) {
                    this.form.application_cycle = ''
                } else if (this.form.application_cycle && !this.selectedCycle) {
                    this.form.application_cycle = ''
                }
            }).catch(() => {
                this.rawReviewCycles = []
                this.form.application_cycle = ''
            })
        },

        formatCycleOptionLabel(cycle) {
            return buildReviewCycleOptionLabel(cycle, this.formatCycleDate)
        },

        formatCycleDate(value) {
            const ts = typeof value === 'number' ? value : Date.parse(value)
            if (!ts || Number.isNaN(ts)) return ''
            return new Date(ts).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            })
        },

        handleBlurChanged(e) {
            let that = this
            setTimeout(() => {
                if (!that.form.sub_account_id || that.accounts.length <= 0) {
                    that.form.sub_account_id = that.form.sub_account_nameEN
                }
            }, 100)
        },

        handleAccoutChanged(e) {
            for (let i = 0; i < this.accounts.length; i++) {
                let account = this.accounts[i]
                if (account._id.$id == this.form.sub_account_id) {
                    this.form.sub_account_nameEN = account.account_nameEN ? account.account_nameEN : account.account_name
                    break
                }
            }
        },

        remoteMethod(keyword) {
            searchSchoolOptions(this, {
                keyword,
                country: this.form.country,
                setKeyword: value => {
                    this.form.sub_account_nameEN = value
                },
                setAccounts: accounts => {
                    this.accounts = accounts
                }
            })
        },
        submit() {
            if (this.isNimTrackLink && this.form.nim_registration_mode === 'makeup' && !this.nilTranscriptVerified) {
                this.$message.warning('Please verify your NIL transcript before submitting.')
                return
            }
            if (this.isNimProject && this.reviewCycles.length > 0 && !this.form.application_cycle) {
                this.$message.warning('Please select a review cycle.')
                return
            }
            if (!this.validateExclusivePartnerBeforeSubmit(this.form.country)) {
                return
            }

            if (!this.isAgree) {
                this.$message.warning("You must agree to the statement.");
                return;
            }
            if (false) {
                console.log('params:' + JSON.stringify(this.form))
                return
            }
            this.$refs.form.validate((val) => {
                if (val) {
                    checkAndConfirmName(this, [
                        { first: this.form.givenName_pinyin, last: this.form.lastName_pinyin, label: 'Name (EN)' },
                        { first: this.form.givenName, last: this.form.lastName, label: 'Name (Native Language)' }
                    ]).then(() => {
                        if (this.requiresIntegrity) {
                            this.flowStep = 2
                            this.scrollContentTop()
                        } else {
                            this.showConfirmDialog = true
                        }
                    }).catch(() => {})
                }
            });
        },
        scrollContentTop() {
            try {
                window.scrollTo(0, 0)
                const el = document.querySelector('.appform')
                if (el) el.scrollTop = 0
            } catch (e) {}
        },
        backToForm() {
            this.flowStep = 1
            this.showConfirmDialog = false
            this.scrollContentTop()
        },
        goToConfirm() {
            this.flowStep = 6
            this.showConfirmDialog = true
            this.scrollContentTop()
        },
        backToIntegrity() {
            this.showConfirmDialog = false
            this.flowStep = 2
            this.scrollContentTop()
        },
        onConfirmBack() {
            if (this.requiresIntegrity) {
                this.backToIntegrity()
            }
        },
        goToRegistrationSuccess(applicationId) {
            const projectKey = this.projectBu === 'DSA' ? 'DSA' : 'registration'
            this.$router.replace({
                path: '/form/success',
                query: {
                    id: applicationId,
                    project: projectKey
                }
            })
        },
        doSubmit() {
            const loading = this.$loading({
                lock: true,
                text: 'Submitting registration...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            if (this.isNimProject) {
                const mode = this.isNimNilLink ? 'nil_only' : (this.form.nim_registration_mode || 'combo')
                const payload = {
                    ...this.form,
                    nim_registration_mode: mode,
                    project_code: this.form.project_code || this.project_code,
                    account_id: this.form.account_id || this.account_id,
                    participation_arrangement: this.form.participation_arrangement
                }
                createNimStudentRegistration(payload).then((res) => {
                    loading.close()
                    const body = res.data || {}
                    if (body.code < 0 || body.status === 'fail' || body.status === 'error') {
                        this.$message.error({
                            message: body.msg || body.message || 'Registration failed. Please try again or contact support.',
                            duration: 8000
                        })
                        return
                    }
                    const data = body.data && body.data._id ? body.data : body
                    const id = data && data._id ? (data._id.$id || data._id) : ''
                    if (!id) {
                        this.$message.error({
                            message: 'Registration failed. Please try again or contact support.',
                            duration: 8000
                        })
                        return
                    }
                    const go = () => this.goToRegistrationSuccess(id)
                    if (data.suspicious_application === true) {
                        showSuspiciousApplicationNotice(this).then(go).catch(go)
                    } else {
                        go()
                    }
                }).catch(() => {
                    loading.close()
                    this.$message.error({
                        message: 'Registration failed. Please try again or contact support.',
                        duration: 8000
                    })
                })
                return
            }
            createApplicationByProjectAndAccount(this.form).then((res) => {
                loading.close();
                // Check for error response
                if (res.data && (res.data.status === 'error' || res.data.code === -1 || res.data.code < 0)) {
                    const errorMsg = res.data.msg || res.data.message || 'Registration failed. Please try again or contact support.';
                    this.$message.error({
                        message: errorMsg,
                        duration: 8000
                    });
                    return;
                }
                // Check if response has data with _id (success case)
                if (res.data && res.data._id) {
                    // Check if application is marked as suspicious
                    if (res.data.suspicious_application === true) {
                        showSuspiciousApplicationNotice(this).then(() => {
                            this.goToRegistrationSuccess(res.data._id.$id)
                        }).catch(() => {
                            this.goToRegistrationSuccess(res.data._id.$id)
                        });
                    } else {
                        this.goToRegistrationSuccess(res.data._id.$id)
                    }
                } else {
                    this.$message.error({
                        message: 'Registration failed. Please try again or contact support.',
                        duration: 8000
                    });
                }
            }).catch((error) => {
                loading.close();
                console.error('Registration error:', error);
                const errorMsg = error.response?.data?.msg || error.response?.data?.message || error.message || 'Registration failed. Please try again or contact support.';
                this.$message.error({
                    message: errorMsg,
                    duration: 8000
                });
            });
        },
    }
})
</script>
<style scoped lang="scss">
::-webkit-scrollbar {
    display: none;
}

.appform {
    font-family: GravityNormal;
    width: 100vw;
    height: 100vh;
    background-color: #FF8E3B;

    .content {
        overflow-y: auto;
        width: 1000px;
        height: 100vh;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 30px 40px 20px;
        background: #fff;
        position: relative;

        .title1 {
            margin-top: 30px;
            font-family: GravityBold;
            color: #FF8E3B;
            font-size: 22px;
            margin-bottom: 50px;
            align-items: center;
            width: 100%;
            font-weight: bold;
            text-align: center;
        }

        .row {
            display: flex;
            justify-content: space-between;

            .item {
                width: 420px;

                .label {
                    font-size: 16px;
                    font-family: GravityNormal;
                    font-weight: normal;
                    color: #666666;
                }

                .input {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    font-size: 18px;

                    font-family: GravityNormal;
                    font-weight: normal;
                    color: #333333;

                    img {
                        margin-right: 24px;
                        cursor: pointer;
                    }
                }
            }
        }

        .single-cycle-row {
            justify-content: flex-start;
        }

        .cycle-hint {
            color: #666;
            font-size: 12px;
            line-height: 16px;
            margin-top: 10px;

            p {
                margin: 0 0 4px;
            }
        }
    }

    .submit {
        .submitBtn {
            font-family: GravityBold;
            width: 280px;
            height: 50px;
            background: #FF8E3B;
            border-radius: 25px;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-size: 20px;
            margin: 0 auto;
            margin-top: 20px;
            cursor: pointer;
        }

        margin-bottom: 50px;
    }

    &.appform--am-subject {
        .submit .submitBtn {
            background: var(--am-accent);
        }

        /deep/ .el-input__inner,
        /deep/ .el-textarea__inner,
        /deep/ .el-select .el-input__inner {
            border-color: var(--am-accent) !important;
        }

        /deep/ .el-input__inner:focus,
        /deep/ .el-textarea__inner:focus {
            border-color: var(--am-accent) !important;
        }
    }

    &.appform--am-institution {
        background: #1B3B6F;

        .content {
            width: calc(min(1040px, 100vw - 32px));
            background: #F7FAFC;
            color: #172033;
            padding: 0 36px 28px;
        }

        .title1 {
            color: #1B3B6F;
            font-size: 18px;
            margin-top: 22px;
            margin-bottom: 28px;
        }
    }

    .am-paid-landing {
        margin: 0 -36px 28px;
        background: #FFFFFF;
        border-bottom: 1px solid #DDE6F1;
    }

    .am-paid-header {
        min-height: 96px;
        padding: 18px 36px;
        background: #FFFFFF;
        border-bottom: 1px solid #E5EAF1;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .am-paid-logo-strip {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 24px;
    }

    .am-paid-logo,
    .am-paid-subject-logo {
        width: 72px;
        height: 72px;
        object-fit: contain;
        display: block;
    }

    .am-paid-hero {
        margin: 28px 36px 16px;
        padding: 24px;
        border-left: 6px solid;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 24px;
        background: #F7FAFC;
    }

    .am-paid-kicker {
        color: var(--am-accent);
        font-family: GravityBold;
        font-size: 13px;
        line-height: 18px;
        text-transform: uppercase;
    }

    .am-paid-hero h1 {
        margin: 8px 0;
        color: #1B3B6F;
        font-family: GravityBold;
        font-size: 32px;
        line-height: 40px;
        letter-spacing: 0;
    }

    .am-paid-hero p {
        margin: 0;
        color: #405169;
        font-size: 15px;
        line-height: 24px;
    }

    .am-paid-chip {
        flex: 0 0 auto;
        color: #FFFFFF;
        border-radius: 6px;
        padding: 8px 12px;
        font-family: GravityBold;
        font-size: 13px;
        line-height: 18px;
    }

    .am-paid-covered {
        margin: 0 36px 16px;
        padding: 14px 16px;
        background: #ECFDF3;
        border: 1px solid #B7E4C7;
        color: #146C43;
        border-radius: 6px;
        font-family: GravityBold;
        line-height: 22px;
    }

    .am-paid-facts {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 1px;
        margin: 0 36px 18px;
        background: #DDE6F1;
        border: 1px solid #DDE6F1;
    }

    .am-paid-fact {
        background: #FFFFFF;
        padding: 14px;
        min-height: 76px;
    }

    .am-paid-fact span {
        display: block;
        color: #69798D;
        font-size: 12px;
        line-height: 18px;
        margin-bottom: 6px;
    }

    .am-paid-fact strong {
        display: block;
        color: #172033;
        font-family: GravityBold;
        font-size: 14px;
        line-height: 20px;
        word-break: keep-all;
        white-space: normal;
    }

    .am-paid-format {
        display: flex;
        align-items: center;
        gap: 10px;
        margin: 0 36px;
        padding: 0 0 24px;
        color: #405169;
        font-size: 13px;
        line-height: 20px;
    }

    .am-paid-format span {
        width: 36px;
        height: 4px;
        border-radius: 2px;
        flex: 0 0 auto;
    }

    .am-paid-footer {
        margin: 18px 0 0;
        color: #69798D;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
    }

    @media (max-width: 768px) {
        &.appform--am-institution {
            .content {
                width: 100vw;
                padding: 0 18px 24px;
            }
        }

        .am-paid-landing {
            margin: 0 -18px 24px;
        }

        .am-paid-header,
        .am-paid-hero {
            flex-direction: column;
        }

        .am-paid-header {
            align-items: flex-start;
            padding: 18px;
        }

        .am-paid-hero,
        .am-paid-covered,
        .am-paid-facts,
        .am-paid-format {
            margin-left: 18px;
            margin-right: 18px;
        }

        .am-paid-hero h1 {
            font-size: 26px;
            line-height: 34px;
        }

        .am-paid-facts {
            grid-template-columns: 1fr;
        }
    }
}
</style>
<style lang="scss">
.appform {
    .el-input__inner {
        border-radius: 6px;
        border-color: var(--am-accent, #FF8E3B);
        font-family: GravityNormal;
    }

    .el-form-item__label {
        font-family: GravityNormal;
    }
}

.appform.appform--am-subject {
    .el-input__inner,
    .el-textarea__inner {
        border-color: var(--am-accent, #FF8E3B) !important;
    }

    .el-input__inner:focus,
    .el-textarea__inner:focus {
        border-color: var(--am-accent, #FF8E3B) !important;
    }
}

.successConfirm {
    width: 470px;

    .el-message-box__status.el-icon-success {
        top: 11% !important;
    }
}
</style>
